<script lang="ts">
	import { onMount } from 'svelte';
	import type { Device } from 'src/types/Device';
	import LiquidLevelIntroductionModal from 'src/components/Modals/Onboarding/LiquidLevel/LiquidLevelIntroductionModal.svelte';
	import SidepanelMainViewHost from 'src/components/Sidepanel/SidepanelMainViewHost.svelte';

	export let device: Device;

	let showIntroductionWizard = false;

	onMount(() => {
		if (!device?.shared && !device?.introductionWizardSeen) {
			showIntroductionWizard = true;
		}
	});
</script>

<SidepanelMainViewHost {device} />

<LiquidLevelIntroductionModal {device} bind:showModal={showIntroductionWizard} />
